export default __webpack_public_path__ + "static/media/companyBanner.eb141a28.png";